import type { Role } from "@/UserContext";
import { CancelledSessionStatuses } from "@/utils/sessions";
import type { SessionStatus } from "../api-types";

// SessionStatus is now imported directly from @/api-types

export const isSessionCancelled = (status: SessionStatus) =>
  CancelledSessionStatuses.includes(status);

export const renderCancelStatus = (
  status: SessionStatus,
  whoIsLooking: Role,
) => {
  if (status === "REQUEST_EXPIRED") {
    return "Request expired";
  }
  if (status === "CANCELLED_BY_OWNER" || status === "DECLINED_BY_OWNER") {
    return whoIsLooking === "owner"
      ? "Cancelled by you"
      : "Cancelled by the owner";
  }
  if (status === "CANCELLED_BY_TRAINER" || status === "DECLINED_BY_TRAINER") {
    return whoIsLooking === "owner"
      ? "Cancelled by the trainer"
      : "Cancelled by you";
  }
  return undefined;
};
